import { render, staticRenderFns } from "./choose-store.vue?vue&type=template&id=0f4bd57e&scoped=true&"
import script from "./choose-store.vue?vue&type=script&lang=js&"
export * from "./choose-store.vue?vue&type=script&lang=js&"
import style0 from "./netin.scss?vue&type=style&index=0&id=0f4bd57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4bd57e",
  null
  
)

export default component.exports